import {match} from 'ts-pattern';

import {SourcingPage} from '../types/SourcingPage';
import {SourcingUserList} from '../types/SourcingUserList';

/** Every Sourcing page except the search results, which is no user list. */
export type SourcingUserListPage = Exclude<SourcingPage, SourcingPage.DEFAULT>;

/**
 * The user list a Sourcing page shows — the one place pages and the bulk action drawer take
 * their list from, so both export and count the same list.
 *
 * The overloads keep the result non-null where the page is known to be a list: a page passing
 * its own `SourcingPage` member gets a `SourcingUserList`, and only a runtime page (the drawer)
 * has to handle the search results' `null`.
 */
export function getSourcingUserListByPage(page: SourcingPage.DEFAULT): null;
export function getSourcingUserListByPage(page: SourcingUserListPage): SourcingUserList;
export function getSourcingUserListByPage(page: SourcingPage): SourcingUserList | null;
export function getSourcingUserListByPage(page: SourcingPage): SourcingUserList | null {
  return match(page)
    .returnType<SourcingUserList | null>()
    .with(SourcingPage.CART_PAGE, () => 'TO_BUY')
    .with(SourcingPage.FAVORITES_PAGE, () => 'FAVOURITE')
    .with(SourcingPage.COMPARISON_PAGE, () => 'COMPARISON')
    .with(SourcingPage.HIDDEN_PAGE, () => 'HIDDEN')
    .with(SourcingPage.CARVAGO_BUY_PAGE, () => 'CARVAGO_BUY')
    .with(SourcingPage.DEFAULT, () => null)
    .exhaustive();
}
